import { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export default function AuthGuard({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const checkAuth = () => {
      const token = localStorage.getItem('access_token');
      const isNewUser = localStorage.getItem('isNewUser') === 'true';
      const hasSeenSplash = localStorage.getItem('hasSeenSplash') === 'true';
      const currentPath = location.pathname;

      const publicRoutes = ['/auth/login', '/auth/register', '/splash'];
      const isPublicRoute = publicRoutes.includes(currentPath);

      // Always show splash first
      if (!hasSeenSplash && currentPath !== '/splash') {
        navigate('/splash');
        setIsChecking(false);
        return;
      }

      if (token) {
        // ✅ Authenticated
        if (currentPath === '/auth/login' || currentPath === '/auth/register') {
          navigate('/');
          setIsChecking(false);
          return;
        }

        if (isNewUser && currentPath !== '/onboarding') {
          navigate('/onboarding');
          setIsChecking(false);
          return;
        }
      } else {
        // ❌ Not authenticated
        if (!isPublicRoute && currentPath !== '/splash') {
          navigate('/auth/login');
          setIsChecking(false);
          return;
        }
      }

      setIsChecking(false);
    };

    checkAuth();
  }, [navigate, location.pathname]);

  if (isChecking) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-orange-400 via-red-500 to-pink-500 flex items-center justify-center">
        <div className="text-center">
          <div className="w-20 h-20 bg-white rounded-3xl shadow-2xl flex items-center justify-center mx-auto mb-6">
            <div className="w-8 h-8 border-3 border-orange-500 border-t-transparent rounded-full animate-spin"></div>
          </div>
          <p className="text-white font-medium">Loading SweetCommerce...</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
